__turbopack_context__.v({
  "accordion": "styles-module-scss-module__IY2doa__accordion",
  "accordionBody": "styles-module-scss-module__IY2doa__accordionBody",
  "arrowUp": "styles-module-scss-module__IY2doa__arrowUp",
  "expanded": "styles-module-scss-module__IY2doa__expanded",
  "hasArrow": "styles-module-scss-module__IY2doa__hasArrow",
  "title": "styles-module-scss-module__IY2doa__title",
});
